import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import useUiModeClassName from '../../hooks/useUiModeClassName.js';
import InputContainer from '../InputContainer/index.js';
import RawInput from '../RawInput/index.js';
import styles from './styles.css.js';

function TextInput(props) {
  const {
    name,
    onChange,
    actions,
    actionsContainerClassName,
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    icons,
    iconsContainerClassName,
    inputSectionClassName,
    label,
    labelContainerClassName,
    readOnly,
    uiMode,
    inputElementRef,
    containerRef,
    inputSectionRef,
    inputClassName,
    inputDescription,
    variant,
    ...textInputProps
  } = props;
  const uiModeClassName = useUiModeClassName(uiMode, styles.light, styles.dark);
  return /*#__PURE__*/React.createElement(InputContainer, {
    containerRef: containerRef,
    inputSectionRef: inputSectionRef,
    actions: actions,
    actionsContainerClassName: actionsContainerClassName,
    className: className,
    disabled: disabled,
    error: error,
    errorContainerClassName: errorContainerClassName,
    hint: hint,
    hintContainerClassName: hintContainerClassName,
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    inputSectionClassName: inputSectionClassName,
    label: label,
    labelContainerClassName: labelContainerClassName,
    readOnly: readOnly,
    uiMode: uiMode,
    inputDescription: inputDescription,
    variant: variant,
    input: /*#__PURE__*/React.createElement(RawInput, _extends({}, textInputProps, {
      name: name,
      onChange: onChange,
      className: _cs(styles.input, uiModeClassName, !!error && styles.errored, inputClassName),
      elementRef: inputElementRef,
      readOnly: readOnly,
      uiMode: uiMode,
      disabled: disabled,
      type: "text"
    }))
  });
}

var TextInput$1 = genericMemo(TextInput);

export { TextInput$1 as default };
//# sourceMappingURL=index.js.map
